import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AppLayout from "./components/Layout/AppLayout";
import Dashboard from "./pages/Dashboard";
// import Dashboard from './pages/extra/Dashboard';
import ProtectedRoute from "./components/protectedRoutes";
import ErrorBoundary from "./components/ErrorBoundary";
import PaymentCollection from "./pages/Accounts/PaymentCollection/PaymentCollectionCustomer";
import CustomerCancelledPayment from "./pages/Accounts/PaymentCollection/PaymentCollectionCustomerCancelled";
import SupplierPayment from "./pages/Accounts/Supplier/SupplierPayment";
import Branches from "./pages/Branches/Branches";
import Brands from "./pages/Brands/Brands";
import BrandsForm from "./pages/Brands/BrandsForm";
import Categories from "./pages/Categories/Categories";
import CategoriesForm from "./pages/Categories/CategoriesForm";
import Customers from "./pages/Customers/Customer";
import Discounts from "./pages/Discounts/Discounts";
import Inventory from "./pages/Inventory/Inventory";
import Login from "./pages/Login";
import Offers from "./pages/Offers/Offers";
import Order from "./pages/Orders/Order";
import DamagedProducts from "./pages/Products/damageProducts";
import ProductForm from "./pages/Products/ProductForm";
import Products from "./pages/Products/Products";
import Profile from "./pages/Profile/Profile";
import Purchase from "./pages/Purchase/Purchase";
import PurchaseForm from "./pages/Purchase/PurchaseForm";
import PurchaseReturn from "./pages/PurchaseReturn/Purchasereturn";
import PurchaseReport from "./pages/Reports/PurchaseReoprt";
import SalesSummary from "./pages/Reports/salesPaymentReport";
import SaleReport from "./pages/Reports/SalesReport";
import SalePos from "./pages/SalePos/SalePos";
import Sale from "./pages/Sales/Sale";
import SaleForm from "./pages/Sales/SaleForm";
import SalesProfit from "./pages/Sales/SalesProfit";
import SaleReplace from "./pages/SalesRetun/SaleReplaced";
import SaleReturn from "./pages/SalesRetun/SaleReturn";
import {
  default as StockMovementReport,
  default as StockMovements,
} from "./pages/StockMovements/StockMovementReport";
import AddStoresProduct from "./pages/StoreProduct/AddStoreProduct";
import Stores from "./pages/stores/Stores";
import StoreStockReport from "./pages/StoreStockReport/StoreStockReport";
import Supplier from "./pages/Supplier/Supplier";
import Taxes from "./pages/Taxes/Taxes";
import User from "./pages/Users/User";
import Warehouses from "./pages/Warehouses/Warehouses";
import StockMovementForm from "./pages/StockMovements/StockMovementForm";
import SalesProfitInvoice from "./pages/Sales/SalesProfitByInvoice";
import ProfitReport from "./pages/Sales/ProfitReport";
import ExpanseHeads from "./pages/Expanses/ExpanseHeads/ExpanseHeads";
import Expanses from "./pages/Expanses/Expanses";
import Employees from "./pages/Employee/Employees";
import EmployeeSalesReport from "./pages/Reports/EmployeeReport";
import CommissionReport from "./pages/Reports/CommissionReport";
import SalesReportTemp from "./pages/Sales/SalesReportTemp";
import ProductSetting from "./pages/ProductSetting/ProductSetting";
import GstReport from "./pages/Accounts/Account/GstReport";
import BalanceSheet from "./pages/Accounts/Account/Balancesheet";
import EmployeeSalary from "./pages/Employee/EmployeeSalary";
import Attendance from "./pages/Employee/Attendance";
import BankAccounts from "./pages/BankAccounts/BankAccounts";
import Tracking from "./pages/Settings/Tracking";
import StockAudit from "./pages/StockAudit/StockAudit";
import ConditionalDashboard from "./components/ConditionalDashboard";
import RcInsurancePayment from "./pages/Sales/RcInsurancePayment";
import RcInsurancePaymentReport from "./pages/Reports/RcInsurancePaymentReport";
import ProductModels from "./pages/ProductModel/ProductModel";
import InvoiceTemplateOne from "./pages/Sales/InvoiceTemplateOne";

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route
            path="/sales/pos"
            element={
              <ProtectedRoute>
                <SalePos />
              </ProtectedRoute>
            }
          />

          <Route
            path="/invoice-template/:saleId"
            element={
              <ProtectedRoute>
                <InvoiceTemplateOne />
              </ProtectedRoute>
            }
          />

          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<ConditionalDashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="products" element={<Products />} />
            <Route path="branches" element={<Branches />} />
            <Route path="customers" element={<Customers />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="orders" element={<Order />} />
            <Route path="sales" element={<Sale />} />
            <Route path="stock-movements" element={<StockMovementReport />} />
            <Route path="stock-movements/add" element={<StockMovementForm />} />
            <Route path="supplier" element={<Supplier />} />
            <Route path="users" element={<User />} />
            <Route path="purchase" element={<Purchase />} />
            <Route path="products/brands" element={<Brands />} />
            <Route path="products/taxes" element={<Taxes />} />
            <Route path="products/product-model" element={<ProductModels />} />
            <Route path="warehouses" element={<Warehouses />} />
            <Route path="discount" element={<Discounts />} />
            <Route path="offers" element={<Offers />} />
            <Route path="stores" element={<Stores />} />
            <Route path="store/stock-add" element={<AddStoresProduct />} />
            <Route path="store-product" element={<AddStoresProduct />} />
            <Route path="store/stock-report" element={<StoreStockReport />} />
            {/* <Route path="store/stockmovement" element={<StockMovements/>}/> */}
            <Route path="sales/salesreturn" element={<SaleReturn />} />
            <Route
              path="purchase/purchasereturn"
              element={<PurchaseReturn />}
            />
            <Route path="productForm" element={<ProductForm />} />
            <Route path="categoriesForm" element={<CategoriesForm />} />
            <Route path="brandsForm" element={<BrandsForm />} />
            <Route path="products/categories" element={<Categories />} />
            <Route path="saleForm" element={<SaleForm />} />
            <Route path="purchaseForm" element={<PurchaseForm />} />
            {/* <Route path="taxes" element={<Taxes/>}/> */}
            <Route path="sales/report" element={<SaleReport />} />
            <Route
              path="rc-payment-insurance/report"
              element={<RcInsurancePaymentReport />}
            />

            <Route path="purchase/report" element={<PurchaseReport />} />
            <Route path="sales/summary" element={<SalesSummary />} />
            <Route path="sales/replaced" element={<SaleReplace />} />
            <Route path="products/damaged" element={<DamagedProducts />} />
            <Route path="/sales/profit" element={<SalesProfit />} />
            <Route
              path="/sales/profit/invoice"
              element={<SalesProfitInvoice />}
            />
            <Route path="/sales/profit-report" element={<ProfitReport />} />

            <Route path="/expense/heads" element={<ExpanseHeads />} />
            <Route path="/expenses" element={<Expanses />} />

            <Route path="/employee" element={<Employees />} />
            <Route path="/employee-salary" element={<EmployeeSalary />} />
            <Route path="/employee-attendance" element={<Attendance />} />
            <Route
              path="/accounts/payments/supplier"
              element={<SupplierPayment />}
            />
            <Route
              path="/accounts/payments/payment-collection"
              element={<PaymentCollection />}
            />
            <Route
              path="/accounts/payments/cancelled"
              element={<CustomerCancelledPayment />}
            />
            <Route path="/employee/report" element={<EmployeeSalesReport />} />
            <Route path="/commission/report" element={<CommissionReport />} />
            <Route
              path="/sales/without-purchase-price"
              element={<SalesReportTemp />}
            />
            <Route path="/accounts/gst-report" element={<GstReport />} />
            <Route path="/accounts/balance-sheet" element={<BalanceSheet />} />

            <Route path="/product/setting" element={<ProductSetting />} />
            <Route path="/bank-accounts" element={<BankAccounts />} />
            <Route path="/tracking" element={<Tracking />} />
            <Route path="/stock-audit" element={<StockAudit />} />
            <Route
              path="/rc-insurance-payment"
              element={<RcInsurancePayment />}
            />
          </Route>
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
